export const customTheme = {
    PRIMARY_BLUE: "#1E3A8A", // Deep blue
    SECONDARY_RED: "#DC2626", // Bright red
    ACCENT_GOLD: "#FFD700", // Gold
    BACKGROUND: "#F3F4F6", // Light gray for background
    TEXT_PRIMARY: "#1F2937", // Dark gray for text
    TEXT_SECONDARY: "#6B7280", // Lighter gray for secondary text
    WHITE: "#FFFFFF",
};